import Link from 'components/link/Link';
import Icon from 'components/icon/Icon';

import { IProposalContact } from 'source/NFR.types';

const ProposalContact: React.FC<IProposalContact> = ({ details = [], title, singleLink }) => {
  return (
    <div className="proposal-contact">
      {title && <span>{title}</span>}
      {details?.map(detail => (
        <Link noHoverEffect={true} key={detail.text} {...detail} />
      ))}{' '}
      {singleLink && singleLink?.url && (
        <a className="link--text proposal-contact__single-link" href={singleLink?.url}>
          <span className="proposal-contact__single-link-text">
            {singleLink.text}
            {singleLink.isExternal && <Icon name="external-link-arrow" className="external-link-icon" />}
          </span>
        </a>
      )}
    </div>
  );
};

ProposalContact.displayName = 'ProposalContact';

export default ProposalContact;
